var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-primary"
  }, [_c('div', {
    staticClass: "footer-primary__contents"
  }, [_c('div', {
    staticClass: "footer-primary__col"
  }, [_c('ul', {
    staticClass: "footer-primary__link"
  }, _vm._l(_vm.links, function (link) {
    return _c('li', {
      key: link.text,
      staticClass: "footer-primary__link-list"
    }, [_c('a', {
      staticClass: "btn",
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.text))])]);
  }), 0), _vm._m(0), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright 2021. KOREA ELECTRONICS ASSOCIATION. All rights reserved.")])]), _vm._m(1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "footer-primary__contact"
  }, [_c('li', [_vm._v("주소(본회) : 03294 서울특별시 마포구 월드컵북로 54길 11 (상암동, 전자회관) 11~12층")]), _c('li', {
    staticClass: "clear"
  }, [_vm._v("주소(센터) : 04366 서울특별시 용산구 청파로 77, 원효상가 6동 3층 KEA 전자제조센터")]), _c('li', {
    staticClass: "clear"
  }, [_vm._v("TEL : 02-6388-6000")]), _c('li', [_vm._v("FAX : 02-6388-6009")]), _c('li', [_vm._v("사업자등록번호 : 220-82-00143")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-primary__col"
  }, [_c('ul', {
    staticClass: "footer-primary__sns"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/icon-y.png",
      "alt": "유튜브"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/icon-f.png",
      "alt": "페이스북"
    }
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/icon-t.png",
      "alt": "트위터"
    }
  })])])])]);
}]

export { render, staticRenderFns }